import { createSelector } from 'reselect';
import get from 'lodash/fp/get';
import { compile } from 'path-to-regexp';
import createDebug from 'utils/createDebug';
import getMatch from './getMatch';

const debugRouter = createDebug('router');

export const getContentTypes = ({ contentType }) => Object.keys(contentType);

export const getTaxonomies = ({ taxonomy }) => Object.keys(taxonomy);

export const getContentGroupTypes = createSelector(
  [getContentTypes, getTaxonomies],
  (contentTypes, taxonomies) => [contentTypes, taxonomies],
);

export const getRouteKey = createSelector(
  [getMatch, get('router')],
  ({ params, path, pathType }, { location: { pathname, search } }) => {
    let routerPath = pathname
    // Make key safe for lodash path resolution.
      .replace(/\.+/g, '')
      // Cap string length to avoid paths of very long strings.
      // Lodash memoizes path resolution for performance, so if
      // we pass in a large string, that will cause large chunks
      // of memory to be taken up without ever being freed by GC.
      // We also shouldn't need a path longer than 100 characters
      // to uniquely identify a route.
      .substring(0, 100);

    // TODO: REMOVE THIS ONCE BERLIN'S REDIRECTS STOP STRIPPING TRAILING SLASHES FROM REQUESTS
    if ('/' !== routerPath) {
      routerPath = routerPath.replace(/\/$/, '');
    }

    debugRouter(`pathType: ${pathType}`);

    // Do not include route :page param in the route key in order to keep
    // all cached `pages` under the same route key
    if (routerPath && Object.keys(params).length && get('page', params)) {
      const toPath = compile(path);
      const pathWithoutPagination = toPath({
        ...params,
        page: null,
      });

      debugRouter(`path: ${pathWithoutPagination}`);
      return `${pathWithoutPagination}${search}`;
    }

    debugRouter(`path: ${routerPath}`);
    return `${routerPath}${search}`;
  },
);

export const getLoading = get('active.loading');

export const getFooter = get('footer');

export const getInfo = ({ info }, path) => get(`${path}`, info);
